/* ==========================================================================
   SearcherFli > Client > Recover State
   ========================================================================== */

const { fromEvent } = require('rxjs');
const { take } = require('rxjs/operators');
const { RANGE, SINGLE } = require('./calendar/constants');
const configuration = require('./config');
const { isOneway } = require('./helpers');
const { actions } = require('./store/actions');

/* Load state */
function loadFromState(instance) {
    const panel = instance;

    const stateInput = panel.element.querySelector(`input[name='${configuration().type.formState}']`);

    fromEvent(window, 'pageshow')
        .pipe(take(1))
        .subscribe(() => {
            if (stateInput && stateInput.value.length > 0) {
                loadState(instance, stateInput.value);
            }
        });
}

function loadState(instance, serializedState) {
    try {
        const searcherState = JSON.parse(serializedState);

        const { data: state, openjaw, crossSelling } = searcherState;

        /* Origin */
        loadOrigin(instance, state);

        /* Destination */
        loadDestination(instance, state);

        /* Calendar */
        loadCalendar(instance, state);

        /* Passengers */
        loadPassengers(instance, state);

        /* Classes */
        loadClasses(instance, state);

        /* Discount */
        loadDiscount(instance, state);

        /* Options */
        loadOptions(instance, state);

        /* Airlines */
        loadAirlines(instance, state);

        /* Openjaw */
        loadOpenjaw(instance, openjaw);

        /* Product */
        loadProduct(instance, state);

        /* Crossselling */
        loadCrossSelling(instance, crossSelling);
    } catch (error) {
        /* Invalid state */
        console.error(error);
    }
}

/* Load origin */
function loadOrigin(instance, state) {
    if (!state.origin || !instance.origin) {
        return;
    }

    instance.origin.actions.setValue(state.origin);
    instance.actions.setSearcher({ origin: state.origin });
}

/* Load destination */
function loadDestination(instance, state) {
    if (!state.destination || !instance.destination) {
        return;
    }

    instance.destination.actions.setValue(state.destination);
    instance.actions.setSearcher({ destination: state.destination });
}

/* Load product */
function loadProduct(instance, state) {
    if (!state.product) {
        return;
    }

    instance.actions.changeProduct(state.product);
}

/* Load calendar */
function loadCalendar(instance, state) {
    if (!state.calendar) {
        return;
    }

    const dates = state.calendar.map(x => new Date(x));
    instance.actions.changeCalendar(dates);
    instance.calendar.actions.setValue(dates);
    instance.calendar.updateInputValue();

    if (isOneway(state.product)) {
        instance.calendar.actions.setMode(SINGLE);
    } else {
        instance.calendar.actions.setMode(RANGE);
    }
}

/* Load passengers */
function loadPassengers(instance, state) {
    if (!state.passengers) {
        return;
    }

    instance.actions.changePassengers(state.passengers);
}

/* Load classes */
function loadClasses(instance, state) {
    if (!state.classes || !state.classes.value) {
        return;
    }

    instance.classes.actions.setOption(state.classes.value);
    instance.actions.setSearcher({ classes: state.classes });
}

/* Load discount */
function loadDiscount(instance, state) {
    if (!state.discount) {
        return;
    }

    instance.actions.changeDiscount(state.discount);
}

/* Load options */
function loadOptions(instance, state) {
    if (!state.option) {
        return;
    }

    state.options.forEach((value, index) => {
        const { checked } = instance.options[index].store.select('checkbox');

        if (value !== checked) {
            instance.options[index].actions.toggle();
        }
    });

    instance.actions.changeOptions(state.options);
}

/* Load airline */
function loadAirlines(instance, state) {
    if (!state.airline) {
        return;
    }

    instance.airlines.actions.setValue(state.airline);
}

/* Load openjaw */
function loadOpenjaw(instance, state) {
    if (!state.rows) {
        return;
    }

    state.rows.forEach(value => {
        instance.store.dispatch(actions.setRow({ ...value, calendar: [new Date(value.calendar)] }));
    });
}

/* Load crossselling */
function loadCrossSelling(instance, state) {
    if (instance.crossSelling) {
        instance.actions.changeCrossSelling(state.includeHotels);

        const { checked } = instance.crossSelling.store.select('toggle');
        if (state.includeHotels !== checked) {
            instance.crossSelling.actions.toggle();
        }
    }
}

module.exports = {
    loadFromState
};
